/**
 * `Spinner` — indicatore di caricamento animato (CSS).
 *
 * Puramente decorativo (`aria-hidden`): l'annuncio testuale allo screen reader
 * è responsabilità del contenitore (es. un `role="status"` con testo). Usare
 * `Loading` per la combinazione spinner + testo accessibile.
 */
import type { ReactNode } from 'react';

interface SpinnerProps {
  size?: 'sm' | 'md';
  className?: string;
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  const style = size === 'sm' ? { width: '1em', height: '1em' } : undefined;
  return (
    <span
      className={['ui-spinner', className ?? ''].filter(Boolean).join(' ')}
      style={style}
      aria-hidden="true"
    />
  );
}

interface LoadingProps {
  /** Testo di stato annunciato (usa `role="status"`). */
  children?: ReactNode;
}

/**
 * `Loading` — spinner + messaggio in un `role="status"` (live region), così lo
 * stato di caricamento è annunciato agli screen reader.
 */
export function Loading({ children = 'Caricamento…' }: LoadingProps) {
  return (
    <p className="ui-loading" role="status">
      <Spinner size="sm" />
      <span>{children}</span>
    </p>
  );
}
